import { Client } from '@/core/entity';
import {
  ClientInput,
  IClientGateway,
  PresenterFunc,
  UpdaterFunc
} from '@/core/interface';

export class CreateClient {
  constructor(
    private readonly clientGateway: IClientGateway,
  ) { }

  public async execute(input: ClientInput, presenter: PresenterFunc<Client | null>, updater?: UpdaterFunc) {
    presenter(null, null, true);

    try {
      const { cse, ...args } = input;
      const result = await this.clientGateway.createClient(args, undefined, updater);

      await this.clientGateway.assignCse(result.id, cse!);

      presenter(null, result, false);
    } catch (err) {
      presenter(err, null, false);
    }
  }
}
